// extracted by mini-css-extract-plugin
export var caretAnchor = "_ug-0";
export var dropdownContent = "_ug-1";